import { Tooltip } from "primereact/tooltip";

import { TipoObraTag } from "../tipo-obra-tag";
import { TIPO_OBRA_SEM_VALOR } from "./tipo-obra-tags.constants";
import type { TipoObraTagsViewModel } from "./types-tipo-obra-tags";

export function TipoObraTagsView(vm: TipoObraTagsViewModel) {
  if (vm.isEmpty) return <span>{TIPO_OBRA_SEM_VALOR}</span>;

  return (
    <span
      className={vm.className}
      title={vm.lista}
      role={vm.role}
      aria-label={vm.lista}
      data-tipo-obra-tags={vm.escopo}
      data-testid="obra-tipos"
    >
      {vm.hasTooltip ? <Tooltip target={vm.tooltipTarget} {...vm.tooltipProps} /> : null}
      {vm.tags.map((tag) => (
        <TipoObraTag
          key={tag.codigo}
          tipo={tag.codigo}
          tooltip={tag.tooltip}
          size={vm.tagSize}
          data-testid={tag.testId}
        />
      ))}
    </span>
  );
}
